<template>
  <div class="inner combo-item display-flex flex-column">
      <button class="badge badge--xs badge--primary badge--top-right"
              @click.stop="choosePizza(item, cbgroupId)" v-if="isPizzaItem(item, comboDetails.is_combo)">{{ $t('customize') }}</button>
      <div class="menu-image" @click.stop="choosePizza(item, cbgroupId)">
        <img v-if="item.image && item.image.desktop_thumbnail"
             v-bind:src="item.image.desktop_thumbnail" style="">
        <img v-else v-bind:src="$const.IMG_PIZZA_DEFAULT" style="">
      </div>
      <div class="flag flag--">
        <span class="flag__inner"></span>
      </div>
      <div class="menu-name text-left" style="z-index: 1">{{item.name}}
        <span class="t10 bold label tag tag-"></span>
      </div>

      <!--COMBO PIZZA's price-->
      <div v-if="hasSelection(item)" class="item-menu__price">{{$t('price')}}:
        {{ $const.CURRENCY }} {{ formatNumDisplay(totalPrice)}}
      </div>
      <!--COMBO SIDE's price-->
      <div v-else class="item-menu__price">
        {{ $const.CURRENCY }} {{ formatNumDisplay(getMinPrice(item))}}
      </div>

      <div class="menu-description hidden-xs " style="z-index: 1">
        <div v-if="item.marketing_description" v-html="nl2brMethod(item.marketing_description)"/>
      </div>

      <div class="d-block pr-10 pl-10 mb-10" v-if="itemSizes.length > 0">
        <div class="card__item__label">
          {{ $t('menu.select_size') }}
        </div>
        <select v-model="selectedSize" class="card__item__select p-10 pr-25 w-full bold">
          <option v-for="size in itemSizes" :key="size.uuid" :value="size">
            {{size.name}}
          </option>
        </select>

        <div class="card__item__label mt-10">
          {{ $t('menu.select_crust') }}
        </div>
        <select v-model="selectedCrust" class="card__item__select p-10 pr-25 w-full bold">
          <option v-for="crust in itemCrustes" :key="crust.uuid" :value="crust">
            {{crust.name}}
          </option>
        </select>
      </div>

      <div style="z-index: 1;display: block;padding: 10px " v-if="!hasSelection(item)">
        <div class="btn btn--primary btn-add-single-item text-center" style="width: 100%;"
             v-on:click.stop="$emit('add-to-basket', item, cbgroupId, iGroup)">
          {{$t('button_add_combo')}}
        </div>
      </div>
      <div v-else class="d-block p-10">
        <div class="btn btn--primary btn-add-single-item text-center" style="width: 100%;"
             v-on:click.stop="setStateSizeNCrust(); $emit('add-to-basket', item, cbgroupId, iGroup);">
          {{$t('button_add_combo')}}
        </div>
      </div>
    </div>
</template>

<script>
import * as types from '@/store/types'
import { mapGetters } from 'vuex'
import ModalCombo from '../popup/ModalCombo.vue'

export default {
  props: ['item', 'cbgroupId', 'iGroup', 'comboDetails', 'comboGroup', 'isMultiple'],
  data() {
    return {
      selectedSize: {},
      selectedCrust: {},
      itemSizes: this.item.first_layers || [],
      itemCrustes: [],
      totalPrice: 0,
      isTrack: true
    }
  },
  watch: {
    selectedSize: function(newValue, oldVal) {
      // calculate total Price (if need)
      this.updateTotalPrice()

      // reload Crust list
      this.itemCrustes = newValue.second_layers
      this.selectedCrust = (newValue.second_layers && newValue.second_layers.length > 0) ?  newValue.second_layers[0] : {}
      this.isTrack = false
      if (oldVal && !this.empty(oldVal) && oldVal.puuid != '') {
        this.trackEventProductClick()
      }
    },
    selectedCrust: function(newValue, oldVal) {
      // calculate total Price (if need)
      this.updateTotalPrice()
      if (this.isTrack) {
        if (oldVal && !this.empty(oldVal) && oldVal.puuid != '') {
          this.trackEventProductClick()
        }
      }
      this.isTrack = true
    },
  },
  created() {
    // Setup default Size&Crust
    this.selectedSize = (this.item.first_layers && this.item.first_layers.length > 0) ? this.item.first_layers[0] : {}
    this.selectedCrust = (this.item.first_layers
      && this.item.first_layers.length > 0
      && this.item.first_layers[0].second_layers.length > 0
    ) ? this.item.first_layers[0].second_layers[0] : {}
  },
  mounted() {},
  computed: {
    ...mapGetters([]),
  },
  methods: {
    trackEventProductClick () {
      let variantUUid = ''
      if (!this.empty(this.selectedSize) && this.selectedSize.uuid != '') {
        variantUUid = this.selectedSize.uuid
      }

      if (!this.empty(this.selectedCrust) && this.selectedCrust != '') {
        variantUUid += '-' + this.selectedCrust.uuid
      }
      let proClick = this._.cloneDeep(this.item)
      proClick.variant_uuid = variantUUid
      this.evenTrackingProductClick(this, proClick, 'product-selection-from-variant-list-main-pizza-list')
      this.eventTrackingProductView(variantUUid, proClick, this)
    },
    hasSelection(item) {
      if (item && item.first_layers && item.first_layers !== undefined) {
        return item.first_layers.length >= 1 || item.first_layers.length == 1 && item.first_layers[0].second_layers.length > 1
      }
      return false
    },
    getMinPrice (item) {
      let price = item.price || 0
      if (item && item.first_layers && item.first_layers !== undefined && item.first_layers.length === 1) {
        price += item.first_layers[0].price || 0
        if (item.first_layers[0].second_layers.length === 1) {
          price += item.first_layers[0].second_layers[0].price || 0
        }
      }
      return price
    },
    /**
     * update total price
     * */
    updateTotalPrice() {
      this.totalPrice = this.item.price > 0 ? parseFloat(this.item.price) : 0

      if (typeof this.selectedSize.price !== 'undefined') {
        this.totalPrice += parseFloat((this.selectedSize.price > 0 ? this.selectedSize.price : 0))
      }
      if (typeof this.selectedCrust.price !== 'undefined') {
        this.totalPrice += parseFloat((this.selectedCrust.price > 0 ? this.selectedCrust.price : 0))
      }
    },
    choosePizza(obj, id) {
      this.$modal.show(ModalCombo, {
        menu: obj,
        sizecrust: this.comboDetails.sizecrustimages,
        extracheese: this.comboDetails.extracheese,
        cGroup: JSON.parse(JSON.stringify(this.comboGroup)),
        id: id,
        comboUUID: this.$route.params.id,
        comboName: this.comboDetails.name,
        isMultiple: this.isMultiple,
        displayCategory: this.comboDetails.display_categories || ''
      }, {class: 'modal-menu', transition: 'nice-modal-fade', overlayTransition: 'overlay-fade'})

      // set state Size & Crust into STORE
      this.setStateSizeNCrust()
    },
    setStateSizeNCrust() {
      this.$store.dispatch(types.SET_SELECTED_SIZE, this.selectedSize)
      this.$store.dispatch(types.SET_SELECTED_CRUST, this.selectedCrust)
    }
  },
}
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/combo/ComboPizzaItem.vue